var map = {
	"./BR2.JPG": 3566,
	"./BR3.JPG": 4027,
	"./BR4.JPG": 1768,
	"./E-yantra.jpeg": 651,
	"./Hands_on_session2023.jpg": 8795,
	"./MERAZ1.JPG": 8748,
	"./Micromouse.jpg": 5358,
	"./RK1.JPG": 8470,
	"./RK2.JPG": 3809,
	"./RK3.JPG": 964,
	"./robodog.jpg": 9509,
	"./session1_2023.jpg": 4896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7453;